import { getApiRoot } from "./apiHelpers";
import { getSpecialQueueType } from "lib/specialGameMode";
import { useUGGPatches } from "lib/hooks/patchHooks";
import { useUGGApiVersions } from "api/uggApiVersions";

export function useTierListURL(options, skipURL = false) {
  const { data: version } = useUGGApiVersions({
    apiKey: "champion_ranking",
    patch: options.patch,
  });
  const specialQueueType = getSpecialQueueType();

  if (specialQueueType && !skipURL) {
    options.queueType = specialQueueType;
  }

  if (
    options.queueType === "normal_aram" ||
    options.queueType === "pick_urf" ||
    options.queueType === "urf" ||
    options.queueType === "arurf" ||
    options.queueType === "nexus_blitz" ||
    options.queueType === "normal_blind_5x5" ||
    options.queueType === "normal_draft_5x5" ||
    options.queueType === "one_for_all"
  ) {
    options.rank = "overall";
  }

  if (options.queueType === "arurf") {
    options.queueType = "urf";
  }

  const root = getApiRoot(options.patch);
  const path = [
    `${root}/champion_ranking`,
    options.region,
    options.patch,
    options.queueType,
    options.rank,
    `${version}.json`,
  ].join("/");
  return path;
}

export function useDuoTierListURL(options) {
  const { data: version } = useUGGApiVersions({
    apiKey: "duos",
    patch: options.patch,
  });
  const root = getApiRoot(options.patch);

  return [`${root}/duos`, options.region, options.patch, options.queueType, options.rank, `${version}.json`].join("/");
}

export function useCombatURL(options) {
  const { data: version } = useUGGApiVersions({
    apiKey: "combat",
    patch: options.patch,
  });

  if (
    options.queueType === "normal_aram" ||
    options.queueType === "urf" ||
    options.queueType === "nexus_blitz" ||
    options.queueType === "normal_blind_5x5" ||
    options.queueType === "normal_draft_5x5" ||
    options.queueType === "one_for_all"
  ) {
    options.rank = "overall";
  }

  const root = getApiRoot(options.patch);
  return [`${root}/table/combat`, options.region, options.patch, options.queueType, options.rank, `${version}.json`].join("/");
}

export function getObjectivesURL(options) {
  const { data: version } = useUGGApiVersions({
    apiKey: "objectives",
    patch: options.patch,
  });

  if (
    options.queueType === "normal_aram" ||
    options.queueType === "urf" ||
    options.queueType === "nexus_blitz" ||
    options.queueType === "normal_blind_5x5" ||
    options.queueType === "normal_draft_5x5" ||
    options.queueType === "one_for_all"
  ) {
    options.rank = "overall";
  }

  const root = getApiRoot(options.patch);
  return [`${root}/table/objective`, options.region, options.patch, options.queueType, options.rank, `${version}.json`].join("/");
}
